document.addEventListener('DOMContentLoaded', async () => {
  const path = window.location.pathname;

  // Detectar idioma actual
  let currentLang = 'es';

  if (path.startsWith('/en/')) {
    currentLang = 'en';
  } else if (path.startsWith('/fr/')) {
    currentLang = 'fr';
  } else if (path.startsWith('/pt/')) {
    currentLang = 'pt';
  }

  // Obtener el handle de la página
  const pagesIndex = path.indexOf('/pages/');

  if (pagesIndex === -1) return;

  let pageHandle = path.substring(pagesIndex + '/pages/'.length);
  pageHandle = pageHandle.replace(/\/$/, '');

  if (!pageHandle) return;

  // URLs reales de los assets de Shopify
  const franciaUrl = "\/\/ineffablecoffee.com\/cdn\/shop\/t\/6\/assets\/francia.json?v=176472116618027054961775659460";
  const portugalUrl = "\/\/ineffablecoffee.com\/cdn\/shop\/t\/6\/assets\/portugal.json?v=15875";

  // Cargar un listado de ciudades
  async function loadCountryList(url) {
    try {
      const response = await fetch(url, {
        cache: 'no-cache'
      });

      if (!response.ok) return [];

      const data = await response.json();

      if (!data.municipios || !Array.isArray(data.municipios)) {
        return [];
      }

      return data.municipios.map(item => item.slug);
    } catch (error) {
      console.error('Error cargando listado SEO:', error);
      return [];
    }
  }

  // Consultar Francia y Portugal
  const [franciaSlugs, portugalSlugs] = await Promise.all([
    loadCountryList(franciaUrl),
    loadCountryList(portugalUrl)
  ]);

  // Por defecto, cualquier página que no esté
  // en Francia o Portugal se considera española.
  let country = 'es';

  if (franciaSlugs.includes(pageHandle)) {
    country = 'fr';
  } else if (portugalSlugs.includes(pageHandle)) {
    country = 'pt';
  }

  // Si el idioma coincide con el país,
  // dejamos que Shopify indexe normalmente.
  if (currentLang === country) return;

  // En cualquier otro idioma:
  // noindex, nofollow
  const robotsMeta = document.createElement('meta');
  robotsMeta.name = 'robots';
  robotsMeta.content = 'noindex,nofollow';

  document.head.appendChild(robotsMeta);
});